import Swiper from 'swiper/bundle';

export default new class ImpactReport {
  constructor() {
    this.observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					const intersecting = entry.isIntersecting
					if (intersecting) {
						switch ((entry.target).dataset.entrance) {
							default:
								if (!entry.target.classList.contains('animated')) {
									entry.target.classList.add('animated')
								}
								break
						}
					}
				})
			},
			{
				rootMargin: '-20% 0px -30% 0px',
				threshold: 0,
			},
		)
  }

  init() {
    this.bindMenu()
    this.bindOurCommunity()
    this.bindInTheNews()
    this.bindAnimations()
  }

  bindMenu() {
    const toggle = document.querySelector('.report-menu-toggle')
    toggle.addEventListener('click', (e) => {
      e.preventDefault()
      document.querySelector('body').classList.toggle('menu-open')
    })

    const closeBtn = document.querySelector('.close-menu')
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault()
      document.querySelector('body').classList.remove('menu-open')
    })

    const sectionButtons = document.querySelectorAll('ul.sections a')
    if(sectionButtons.length) {
      sectionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          document.querySelector('body').classList.remove('menu-open')
        })
      })
    }
  }

  bindOurCommunity() {
    const section = document.querySelector('section.our-community')
    const buttons = section.querySelectorAll('.options a')

    if(buttons.length) {
      buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault()
          let curActiveButton = section.querySelector('.options a.active')
          curActiveButton.classList.remove('active')

          let curActivePane = section.querySelector('.pane.active')
          curActivePane.classList.remove('active')

          button.classList.add('active')
          const activeIndex = button.dataset.index
          section.querySelectorAll('.pane')[activeIndex].classList.add('active')
        })
      })
    }
  }

  bindInTheNews() {
    new Swiper('.in-the-media-swiper', {
      loop: true,
      slidesPerGroup: 1,
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerGroup: 2,
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerGroup: 3,
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    })
  }

  bindAnimations() {
    const animatedItems = document.querySelectorAll('[data-entrance]')

    animatedItems.forEach((el) => {
      this.observer.observe(el)
    })
  }
}